import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  Box,
} from '@mui/material';
import { PaymentRecord } from '../../services/invoiceService';

interface PaymentHistoryTableProps {
  payments: PaymentRecord[];
  emptyMessage?: string;
}

const getPaymentMethodLabel = (method: string): string => {
  const labels: Record<string, string> = {
    CASH: 'Cash',
    CHEQUE: 'Cheque',
    BANK_TRANSFER: 'Bank Transfer',
    UPI: 'UPI',
    CARD: 'Card',
  };
  return labels[method] || method;
};

const getPaymentMethodColor = (method: string): 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'info' => {
  const colors: Record<string, 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'info'> = {
    CASH: 'success',
    CHEQUE: 'warning',
    BANK_TRANSFER: 'primary',
    UPI: 'info',
    CARD: 'secondary',
  };
  return colors[method] || 'default';
};

const PaymentHistoryTable: React.FC<PaymentHistoryTableProps> = ({
  payments,
  emptyMessage = 'No payments recorded yet',
}) => {
  if (!payments || payments.length === 0) {
    return (
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">{emptyMessage}</Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: 'grey.100' }}>
            <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Method</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Reference</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Recorded By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {payments.map((payment) => (
            <TableRow key={payment.id} hover>
              <TableCell>
                {new Date(payment.paymentDate).toLocaleDateString('en-IN', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })}
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                {payment.paymentAmountFormatted}
              </TableCell>
              <TableCell>
                <Chip
                  label={getPaymentMethodLabel(payment.paymentMethod)}
                  size="small"
                  color={getPaymentMethodColor(payment.paymentMethod)}
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                {payment.referenceNumber || '-'}
              </TableCell>
              <TableCell>
                {payment.recordedByName || '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PaymentHistoryTable;
